// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { createHooksHooks } from "./hooks.js";
export const createHooksExtensions = (client) => createHooksHooks(client);
export const hooksOperations = [
    { method: "POST", path: "/hooks/payouts", accessor: "hooks.createPayout" },
    { method: "POST", path: "/hooks/payment-call/bolna", accessor: "hooks.updatePaymentCallBolna" },
];
//# sourceMappingURL=index.js.map